import React from 'react';
import { Box, Typography } from '@mui/material';
import { getResponsiveHeight, getResponsiveSize } from '../../utils/responsive';
import globalStyles from '../../global';

const FranchiseCards = () => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const franchiseData = [
    {
      region: 'INDIA',
      background: 'white',
      imagePath: '/India.png',
    },
    {
      region: 'NEPAL',
      background: '#F2F3F0',
      imagePath: '/Nepal.png',
    },
    {
      region: 'BANGLADESH',
      background: 'white',
      imagePath: '/bangladesh.png',
    },
    {
      region: 'UAE',
      background: '#F2F3F0',
      imagePath: '/uae.png',
    },
  ];

  const SingleCard = ({ region, background, imagePath }) => (
    <Box sx={{ ...styles.cardContainer, backgroundColor: background }}>
      <Typography sx={styles.backgroundText}>{region}</Typography>

      <Box sx={styles.contentWrapper}>
        <Typography sx={styles.sideDescription}>
          From Humble Beginnings In India To Over 650+ Franchises Across Asia,
          UClean Has Revolutionized The Laundry Industry With Its Innovative,
          Tech-Enabled Solutions.
        </Typography>

        <Box sx={styles.circleContainer}>
          <Box sx={styles.dottedCircle}>
            <img
              src={`${imageBaseUrl}${imagePath}`}
              alt={`${region} Franchise`}
              style={{
                width: '80%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
        </Box>
        <Typography sx={styles.sideDescription}>
          From Humble Beginnings In India To Over 650+ Franchises Across Asia,
          UClean Has Revolutionized The Laundry Industry With Its Innovative,
          Tech-Enabled Solutions.
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box sx={styles.mainContainer}>
      {franchiseData.map((data, index) => (
        <SingleCard
          key={index}
          region={data.region}
          background={data.background}
          imagePath={data.imagePath}
        />
      ))}
    </Box>
  );
};

const styles = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardContainer: {
    height: getResponsiveHeight(600),
    position: 'relative',
    padding: getResponsiveSize(6),
    minHeight: getResponsiveSize(300),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  typograph: {
    color: globalStyles.colors.army_green,
    fontSize: getResponsiveSize(45),
   fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  backgroundText: {
   fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    position: 'absolute',
    top: '22%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: getResponsiveSize(200),
    color: '#e6e8e2',
    whiteSpace: 'nowrap',
    zIndex: 0,
  },
  contentWrapper: {
    // width: '100%',
    maxWidth: getResponsiveSize(1200),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: getResponsiveSize(4),
    zIndex: 1,
    position: 'relative',
  },
  sideDescription: {
    flex: 1,
    fontSize: getResponsiveSize(14),
    color: '#666',
    lineHeight: 1.6,
    maxWidth: getResponsiveSize(300),
  },
  circleContainer: {
    top: '90%',
    flex: '0 0 auto',
    width: getResponsiveSize(471.25),
    height: getResponsiveSize(471.25),
    position: 'relative',
  },
  dottedCircle: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
};

export default FranchiseCards;
